module.exports = __webpack_public_path__ + "static/img/bg_04.a9fc0f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg_04.jpg
// module id = 9H/N
// module chunks = 1